<template>
  <div class="app-tag-view-model">
    <div class="atvm-btn-left" @click="onPrev"><i class="el-icon el-icon-arrow-left"></i></div>
    <div class="atvm-wrapper" id="jWrapperBox">
      <div class="atvm-wrap-content" id="jWrapContentBox">
        <div class="atvm-item" v-for="(item,$index) in tagViewList" :key="$index">
          <m-tag-view-item :item="item" :index="$index" @on-tag-toggle="onTagToggle"/>
        </div>
      </div>
    </div>
    <div class="atvm-btn-right" @click="onNext"><i class="el-icon el-icon-arrow-right"></i></div>
    <div class="atvm-btn-close">
      <el-dropdown @command="onCommand">
        <span class="el-dropdown-link">
          <i class="el-icon el-icon-circle-close"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="all">关闭所有</el-dropdown-item>
            <el-dropdown-item command="other">关闭其他</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import Ps from '@/module/ps'
  import { mapState, mapMutations } from 'vuex'
  import mTagViewItem from './tagViewItem'
  import { ignorePaths } from './ignore'
  import { getParents, handlerCurrentMenu, handlerRouteItem } from './utils'

  /**
   * 临时赶工，后期重新梳理路由问题
   * 这是个可怕的操作！！！
   */
  export default {
    name: 'app-tag-view',
    data () {
      return {
        scrollAx: 0,
        currentPath: '/home',
        currentItem: {},
        tagViewData: [],
        isSystemInit: false
      }
    },
    props: {},
    methods: {
      ...mapMutations('common', ['setTagViewList', 'setCurrentParentPath', 'setCurrentTagItem', 'setArrTagViewList']),
      onCommand (v) {
        switch (v) {
          case 'all':
            this.removeTagAll()
            break
          case 'other':
            this.removeTagOther()
            break
        }
      },
      removeTagAll () {
        this.setArrTagViewList([])
        this.$router.push(`${this.isErp ? '/cloud/o2o/order/manage' : '/home'}`)
      },
      removeTagOther () {
        this.setArrTagViewList([this.currentTagItem])
      },
      onPrev () {
        if (this.scrollAx > 0) {
          this.scrollAx = this.scrollAx - 400
          this.scrollHandler()
        }
      },
      onNext () {
        if (this.scrollAx < $('#jWrapContentBox').width()) {
          this.scrollAx = this.scrollAx + 400
          this.scrollHandler()
        }
      },
      scrollHandler () {
        $('#jWrapperBox').animate({
          scrollLeft: this.scrollAx
        }, 400)
      },
      onTagToggle ({ name, query }) {
        const params = Ps.handlerQuery(query, true)
        const left = $(`#${name}-${params}`).position().left
        this.scrollAx = left
        const jWrapperBox = $('#jWrapperBox')
        jWrapperBox.animate({ scrollLeft: left }, 400)
      },
      handlerScrollPos () {
        const jWrapperBox = $('#jWrapperBox')
        const w = jWrapperBox.width()
        this.scrollAx = w
        jWrapperBox.animate({ scrollLeft: w }, 400)
      },
      num (vItem) {
        const t = _.map(_.map(this.tagViewList, v => {
          return {
            ...v,
            pathParams: `${v.path}${Ps.handlerQuery(v.query)}`
          }
        }), 'pathParams')

        return t.includes(`${vItem.path}${Ps.handlerQuery(vItem.query)}`)
      }
    },
    watch: {
      '$route': {
        deep: true,
        immediate: true,
        handler (v) {
          const g = Ps.handlerPath(v)
          let routeItem = { ...Ps.getRouteItem(g), query: v.query }
          routeItem = handlerRouteItem(routeItem)

          console.log('tagView watch route', routeItem, routeItem.path, _.isEmpty(routeItem.path))
          if (_.isEmpty(routeItem.path)) {
            this.$router.push('/app-error404')
            return
          }

          // 忽略添加到tagView
          if (this.isSystemInit && ignorePaths.includes(v.path)) return

          // 缓存标签列表
          this.setTagViewList(routeItem)
          // 缓存当前标签所有属性
          this.setCurrentTagItem(routeItem)
          // 缓存当前标签的父级path
          const nodes = Ps.getRoutes()[g.system]
          const phasePaths = _.uniq(getParents(g.path, nodes))
          this.setCurrentParentPath(phasePaths)
          // 缓存选中菜单数据
          handlerCurrentMenu(phasePaths)

          if (!this.num(v)) {
            this.handlerScrollPos()
          }
        }
      }
    },
    beforeCreate () {
    },
    created () {
      this.isSystemInit = true
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['tagViewList', 'currentTagItem', 'isErp'])
    },
    components: { mTagViewItem }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .app-tag-view-model {
    position: relative;
    height: 40px;
    width: calc(100% - 1px);
    overflow: hidden;
    background: #fff;
    border: 1px solid #f0f0f0;
    .atvm-btn-left,.atvm-wrapper,.atvm-btn-right,.atvm-btn-close {
      float: left;
      height: 40px;
    }

    .el-icon {
      color: #888;
    }

    .atvm-btn-left,.atvm-btn-right,.atvm-btn-close {
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      &:hover {
        .el-icon {
          color: #000;
        }
      }
    }
    .atvm-btn-close {
      width: 32px;
    }
    .atvm-btn-left,.atvm-btn-right {
      width: 26px;
    }
    .atvm-btn-right {
      border-right: 1px solid #f0f0f0;
    }
    .atvm-wrapper {
      width: calc(100% - 87px);
      height: 57px;
      border-left: 1px solid #f0f0f0;
      border-right: 1px solid #f0f0f0;
      position: relative;
      overflow-x: scroll;
      .atvm-wrap-content {
        width: max-content;
        overflow: hidden;
        padding: 1px 0px 1px 4px;
        -ms-transition: all 0.6s ease-out;
        -moz-transition: all 0.6s ease-out;
        -webkit-transition: all 0.6s ease-out;
        -o-transition: all 0.6s ease-out;
        .atvm-item {
          float: left;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/tagView.vue